
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 161.8 148.17"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M74.93 120.1l7.21-35.18a11.1 11.1 0 00-11.87-13.28L34.5 74.87c-10.7 1-15.39 13.74-8 21.95l3.92 4.39L1.8 126.76a5.64 5.64 0 00-.3 8l10.26 11.48a5.64 5.64 0 008 .59l28.58-25.55 3.93 4.4c7.29 8.18 20.51 4.95 22.66-5.58zM127.3 73.3l-35.77 3.22a11.1 11.1 0 01-11.87-13.27l7.21-35.18c2.16-10.53 15.37-13.76 22.71-5.55l3.93 4.4 28.58-25.55A5.64 5.64 0 01150 2l10.3 11.44a5.64 5.64 0 01-.3 8L131.42 47l3.93 4.39c7.34 8.17 2.65 20.94-8.05 21.91z"}})])
          )
        }
      }
    